"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.signatureInputSchema = exports.default = void 0;
var SignatureInput_1 = require("./SignatureInput");
Object.defineProperty(exports, "default", { enumerable: true, get: function () { return __importDefault(SignatureInput_1).default; } });
Object.defineProperty(exports, "signatureInputSchema", { enumerable: true, get: function () { return SignatureInput_1.signatureInputSchema; } });
//# sourceMappingURL=index.js.map